export const ALLEGIANCE_TRUC = 158;
export const LRM_LEASING = 141;
export const ALLEGIANCE_NEW_ENGLAND = 171;

export default [ALLEGIANCE_TRUC, LRM_LEASING, ALLEGIANCE_NEW_ENGLAND];
